import React from 'react';
import { Link } from 'react-router-dom';

const BlogCtaSection = () => {
  return (
    <section aria-labelledby="cta-title">
      <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg site-card text-center">
        <h2 id="cta-title" className="text-3xl font-bold text-gray-900">
          Quer acompanhar?
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Se quiser sugerir um tema, enviar feedback técnico ou colaborar em um estudo, vamos
          conversar.
        </p>
        <div className="mt-8">
          <Link
            to="/contato"
            className="inline-flex items-center rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Falar comigo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogCtaSection;
